module.exports = __webpack_public_path__ + "img/amountGroup.6ca873e4.png";